// extracted by mini-css-extract-plugin
module.exports = {"parent":"Footer_parent__9vYIj","footer":"Footer_footer__1w0lV"};